<template>
    <div>
        <div class="box">
            <div class="item">
                <img class="item-img" :src="img" alt="col" />
            </div>
            <div class="item item-text">
                <h3 class="reveal-bottom">{{ $t("h.c2_t") }}</h3>
                <p class="reveal-bottom">
                    {{ $t("h.c2_c") }}
                </p>
            </div>
            <div class="item item-text">
                <h3 class="reveal-bottom">{{ $t("h.c2_t1") }}</h3>
                <p class="reveal-bottom">
                    {{ $t("h.c2_c1") }}
                </p>
            </div>
            <div class="item ">
                <img class="item-img" :src="img1" alt="col" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "content2",
    data() {
        return {
            img: require("@/assets/images/home_spec_col_1.jpg"),
            img1: require("@/assets/images/home_spec_col_2.jpg"),
        };
    },
};
</script>
<style scoped>
.box {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    margin: 150px auto 150px;
    padding: 0 10px;
    box-sizing: border-box;
}
.item {
    width: 590px;
    height: 400px;
    background-color: #000;
    box-sizing: border-box;
}
.item-text {
    padding: 55px;
}
.item-img {
    width: 100%;
    height: 100%;
}
.item > h3 {
    font-size: 28px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 50px;
    font-weight: bold;
}
.item > p {
    font-size: 18px;
    color: #ffffff;
    line-height: 32px;
    margin-top: 31px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Home/Content2.vue